// Nilai Stase peserta -- cermin STASE_VALID di server.py (satu daftar utk form, filter & Ubah massal).
// "Belum Stase" (keputusan pemilik 21 Okt 2026): PPDS yg sudah melewati MDU-MDK tetapi belum Stase; khusus
// Sp1/Sp2 (server menolak utk Koas), tidak wajib isi Rotasi Klinik seperti MDU-MDK & Penelitian.
export const STASE_BELUM = "Belum Stase";
export const STASE_OPSI = ["Stase RSCM", "Stase Luar", "MDU-MDK", "Penelitian", STASE_BELUM];

// Pilihan Stase utk jenjang tertentu: "Belum Stase" tidak ditawarkan utk Koas. jenjang kosong/"all" = semua.
export function opsiStase(jenjang) {
    return jenjang === "Koas" ? STASE_OPSI.filter((s) => s !== STASE_BELUM) : STASE_OPSI;
}
